import React, { useEffect, useState, useContext } from 'react'
import ListingTableView from '@/product/components/organisms/Product/TableView'
import { Button } from '@mui/material'
import ReportContext from '@/product/context/report/reportContext'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import { styled } from '@mui/material/styles'
import DynamicAuctionListing from '../AuctionLots/dynamicListing'
import { useFormik } from 'formik'
import AuctionContext from '@/product/context/auction/auctionContext'
import DynamicListing from '../Listing/dynamicListing'
import DynamicBulkListing from '@/product/components/organisms/BulkUpload/ProjectUpload'
import DynamicManifest from '@/product/components/organisms/BulkUpload/ManifestUpload'
import DynamicBulkImage from '@/product/components/organisms/BulkUpload/ProjectImage'
import CustomCommonContext from '@/custom/context/common/commonContext'
import { useHistory } from 'react-router-dom'
import { handleRedirectInternal } from '@/product/common/components'

import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'

import CatalogSearch from './CatalogSearch'
import ManifestContext from '@/product/context/manifest/manifestContext'
import Layout from '@/product/components/templates/Layout'

import FieldHeader from './FieldHeader'

const PREFIX = 'ERP'

const classes = {
    root: `${PREFIX}-root`,
}

const StyledLayout = styled(Layout)(({ theme }) => ({
    [`& .${classes.root}`]: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}))

const Manifest = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const { getAllExportDownload } = useContext(ReportContext)
    const {
        getAllManifestProducts,
        all_manifest_products,
        responseStatus: responseManifestUpload,
        clearResponse: clearManifestResponse,
    } = useContext(ManifestContext)

    const auctionContext = useContext(AuctionContext)

    const {
        project_tablefields,
        project_dynamicfields,
        propertyColumnReOrder,
    } = dynamicContext

    const { all_auctions, getAllAuctions, responseStatus, clearResponse } =
        auctionContext
    const { alldata_all_dropdown } = useContext(CustomCommonContext)
    const [configValues, setConfigValues] = useState({
        qty: 1,
        auction: 1,
    })

    const history = useHistory()
    const [custom, setCustom] = useState({})
    const [tableBody, setTableBody] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
    })
    const [auctionManage, setAuctionManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
    })
    const [bulkPopup, setBulkPopup] = useState(false)
    const [aucId, setAucId] = useState('')
    const [lotStatus, setLotStatus] = useState('draft')
    const [bulkImagePopup, setBulkImagePopup] = useState(false)
    const [catalogPopup, setCatalogPopup] = useState(false)
    const [manifestPopup, setManifestPopup] = useState(false)

    const toggleBulkImagePopup = (popup) => {
        setBulkImagePopup({ popup })
    }
    const toggleCatalogPopup = (popup) => {
        setCatalogPopup({ popup })
    }

    const toggleBulkPopup = (popup) => {
        setBulkPopup({ popup })
    }

    const toggleManifestPopup = (popup) => {
        setManifestPopup({ popup })
    }

    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'manifest') {
            handleRedirectInternal(history, `listing/manifest/${id}`)
        }
    }

    const getMultipleAction = () => {
        let actionPush = []

        actionPush.push({
            field: 'action',
            type: 'button',
            clickType: 'manifest',
            onclick: onClickEdit,
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            tooltipTitle: 'Add to Inventory',
            buttonType: 'add',
        })

        return actionPush
    }

    const tableValues = [
        {
            field: 'retailer',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Retailer',
            filterable: true,
            filterField: 'm.retailer',
        },
        {
            field: 'image_1_url',
            type: 'imagewithurl',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Images',
            // filterable: true,
            // filterField: 'm.image_1_url',
        },

        {
            field: 'upc',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'UPC',
            filterable: true,
            filterField: 'm.upc',
        },
        {
            field: 'ean',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'EAN',
            filterable: true,
            filterField: 'm.ean',
        },
        {
            field: 'isbn',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'ISBN',
            filterable: true,
            filterField: 'm.isbn',
        },
        {
            field: 'gtin',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'GTIN',
            filterable: true,
            filterField: 'm.gtin',
        },
        {
            field: 'asin',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'ASIN',
            filterable: true,
            filterField: 'm.asin',
        },

        {
            field: 'wis',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'WIS',
            filterable: true,
            filterField: 'm.wis',
        },

        {
            field: 'his',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'HIS',
            filterable: true,
            filterField: 'm.his',
        },
        {
            field: 'lis',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'LIS',
            filterable: true,
            filterField: 'm.lis',
        },
        {
            field: 'itf14s',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'ITF14S',
            filterable: true,
            filterField: 'm.itf14s',
        },
        {
            field: 'fnsku',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'FNSKU',
            filterable: true,
            filterField: 'm.fnsku',
        },
        {
            field: 'fcsku',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'FCSKU',
            filterable: true,
            filterField: 'm.fcsku',
        },
        {
            field: 'lpn',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'LPN',
            filterable: true,
            filterField: 'm.lpn',
        },
        {
            field: 'xcab',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'XCAB',
            filterable: true,
            filterField: 'm.xcab',
        },
        {
            field: 'vendor_name',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Vendor Name',
            filterable: true,
            filterField: 'm.vendor_name',
        },
        {
            field: 'vendor_code',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Vendor Code',
            filterable: true,
            filterField: 'm.vendor_code',
        },
        {
            field: 'vendor_warehouse_location',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Vendor Warehouse',
            filterable: true,
            filterField: 'm.vendor_warehouse_location',
        },
        {
            field: 'po_number',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'PO Number',
            filterable: true,
            filterField: 'm.po_number',
        },
        {
            field: 'cost_per_unit',
            type: 'price',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Cost per unit',
            filterable: true,
            filterField: 'm.cost_per_unit',
        },
        {
            field: 'quantity',
            type: 'number',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Quantity',
            filterable: true,
            filterField: 'm.quantity',
        },
        {
            field: 'carrier',
            type: 'text',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Carrier',
            filterable: true,
            filterField: 'm.carrier',
        },
        {
            field: 'carrier_tracking',
            type: 'text',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Carrier Tracking',
            filterable: true,
            filterField: 'm.carrier_tracking',
        },
        {
            field: 'ship_to_location',
            type: 'text',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Ship To Location',
            filterable: true,
            filterField: 'm.ship_to_location',
        },
        {
            field: 'truck_number',
            type: 'text',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Truck Number',
            filterable: true,
            filterField: 'm.truck_number',
        },
        {
            field: 'pallet_number',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Pallet Number',
            filterable: true,
            filterField: 'm.pallet_number',
        },
        {
            field: 'retailer_load',
            type: 'text',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Retailer Load',
            filterable: true,
            filterField: 'm.retailer_load',
        },
        {
            field: 'manufacturer_name',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Manufacturer Name',
            filterable: true,
            filterField: 'm.manufacturer_name',
        },
        {
            field: 'manufacturer_sku',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Manufacturer SKU',
            filterable: true,
            filterField: 'm.manufacturer_sku',
        },
        {
            field: 'category',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Category',
            filterable: true,
            filterField: 'm.category',
        },
        {
            field: 'item_title',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Item Title',
            filterable: true,
            filterField: 'm.item_title',
        },
        {
            field: 'description',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Item Description',
            filterable: true,
            filterField: 'm.description',
        },
        {
            field: 'manifest_retail',
            type: '',
            // sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Manifest Retail',
            filterable: true,
            filterField: 'm.manifest_retail',
        },

        {
            field: 'actual_retail',
            type: '',
            // sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Actual Retail Price',
            filterable: true,
            filterField: 'm.actual_retail',
        },
        {
            field: 'warehouse_location',
            type: '',
            // sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Warehouse Location',
            filterable: true,
            filterField: 'm.warehouse_location',
        },
        {
            field: 'bin_location',
            type: '',
            // sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Bin Location',
            filterable: true,
            filterField: 'm.bin_location',
        },
        {
            field: 'customer_tag',
            type: '',
            // sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Customer Tags',
            filterable: true,
            filterField: 'm.customer_tag',
        },

        {
            field: 'action',
            type: 'button',
            isMultiple: true,
            clickID: 'id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAction(),
        },
    ]

    const formik = useFormik({
        initialValues: {
            limit: 20,
            page: 1,
            orderby: '',
            order: '',
            filters: {
                action: {
                    value: '',
                    type: 'in',
                    field: 'm.market_status',
                },
                asin_id: {
                    type: 'like',
                    value: '',
                    field: 'm.asin',
                },
                title: {
                    type: 'like',
                    value: '',
                    field: 'm.item_title',
                },
                retailer: {
                    type: 'like',
                    value: '',
                    field: 'm.retailer',
                },
            },
        },
        enableReinitialize: false,
        onSubmit: (values) => {
            setIsLoading(true)
            getAllManifestProducts(values)
        },
    })

    const [value, setValue] = useState(0)

    useEffect(() => {
        setIsLoading(true)
        getAllManifestProducts(formik.values)
    }, [])

    const additionalFilterCallBack = (data) => {
        setLotStatus(data.lots)
        setAucId(data.auctions)
    }

    const resetForm = () => {
        // formik.values.filters.invoice.value = ''
        // formik.values.filters.auction.value = ''
        // formik.values.filters.first_name.value = ''
        // formik.values.filters.last_name.value = ''
        // formik.values.filters.fromdate.value = ''
        // formik.values.filters.todate.value = ''
        formik.values.filters.asin_id.value = ''
        formik.values.filters.title.value = ''
        formik.values.filters.retailer.value = ''

        //getAllAppointments(formik.values)
    }

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'ASIN ID',
                placeholder: 'Enter Asin Id',
                class: 'col-12 erp_po_cnt',
                type: 'text',
                name: 'asin_id',
                filter: true,
            },
            {
                label: 'Title',
                placeholder: 'Enter Title',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'title',
                filter: true,
            },
            {
                label: 'Retailer',
                placeholder: 'Select Retailer',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'select',
                options: [
                    { show: 'Amazon', value: 'Amazon' },
                    { show: 'Home Depot', value: 'Home Depot' },
                    { show: 'Walmart', value: 'Walmart' },
                ],
                name: 'retailer',
                filter: true,
            },
            // {
            //     label: 'Invoice ID',
            //     placeholder: 'Enter Invoice ID',
            //     class: 'col-md-4 col-sm-6 col-12',
            //     type: 'text',
            //     name: 'invoice',
            //     filter: true,
            // },
            // {
            //     label: 'Auction Name',
            //     placeholder: 'Enter Auction name',
            //     class: 'col-md-4 col-sm-6 col-12',
            //     type: 'text',
            //     name: 'auction',
            //     filter: true,
            // },
            // {
            //     label: 'First Name',
            //     placeholder: 'Enter First Name',
            //     class: 'col-md-4 col-sm-6 col-12',
            //     type: 'text',
            //     name: 'first_name',
            //     filter: true,
            // },
            // {
            //     label: 'Last Name',
            //     placeholder: 'Enter Last Name',
            //     class: 'col-md-4 col-sm-6 col-12',
            //     type: 'text',
            //     name: 'last_name',
            //     filter: true,
            // },
            // {
            //     label: 'From Date',
            //     placeholder: 'Date Ending From',
            //     class: 'col-md-4 col-sm-6 col-12',
            //     type: 'date',
            //     name: 'fromdate',
            //     filter: true,
            // },
            // {
            //     label: 'To Date',
            //     placeholder: 'Date Ending To',
            //     class: 'col-md-4 col-sm-6 col-12',
            //     type: 'date',
            //     name: 'todate',
            //     filter: true,
            // },
        ],
    }

    const tableActions = []

    useEffect(() => {
        if (responseManifestUpload) {
            if (
                responseManifestUpload.status === 'success' &&
                responseManifestUpload.from === 'uploadXLSXFile'
            ) {
                getAllManifestProducts(formik.values)
            }
            clearManifestResponse()
        }
    }, [responseManifestUpload])

    useEffect(() => {
        if (all_manifest_products) {
            setTableBody(
                all_manifest_products.records.length
                    ? all_manifest_products.records
                    : []
            )
        }
        setIsLoading(false)
    }, [all_manifest_products])

    console.log('all_manifest_products', all_manifest_products)
    return (
        <StyledLayout
            noUI={props.noUI || false}
            renderSidePanelDefault={props.renderSidePanelDefault || false}
        >
            <div className="dashboard listing maillisting erpMisc manifestErp">
                <FieldHeader
                    acceptDuplicateItem={props?.acceptDuplicateItem}
                    skipRetailerFetch={props?.skipRetailerFetch}
                    type="manifest"
                />

                <div className="erpTabs">
                    <CustomSearch
                        searchInfo={searchInfo}
                        formik={formik}
                        advFilters={true}
                        resetForm={resetForm}
                    />

                    <CustomTable
                        formik={formik.values}
                        tableBody={tableBody}
                        tableValues={tableValues}
                        tableActions={tableActions}
                        allData={all_manifest_products}
                        isLoading={isLoading}
                        loadingTemplate={'table'}
                        changeTableFunction={getAllManifestProducts}
                    />
                </div>
            </div>
        </StyledLayout>
    )
}

export default Manifest
